// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1CTKi","footer":"ModalUpdate_footer__3d-IW"};